var render = function render(){var _vm=this,_c=_vm._self._c;return _c('community-member',{class:_vm.index%2===0 ? 'even' : 'odd',attrs:{"user":_vm.source}})
}
var staticRenderFns = []

export { render, staticRenderFns }